module.exports = __webpack_public_path__ + "static/media/different-equation-box-bg.8575c0b0.png";